import { css, html, LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'
import { TextBlockElementModel, TextSettingsElementModel } from '../api/ContentDeliveryApi.schemas'
import { unsafeHTML } from 'lit/directives/unsafe-html.js'
import { RenderButton } from '../Shared/Button'
import { RichTextStyles } from '../Shared/RichText'

@customElement('lindberg-text-area')
export class TextArea extends LitElement {
	static styles = [RichTextStyles, css`
        :host { 
            display: grid;
            grid-template-columns: repeat(12, 1fr);
            column-gap: var(--space-100);
            color: light-dark(var(--color-text-base-dark), var(--color-text-base-light));
            
            @media (width >= 1160px) {
                column-gap: var(--space-200);
            }
            @media (width < 600px) {
                grid-template-columns: repeat(4, 1fr);
            }
            grid-auto-flow: row;
            align-self: var(--vertical-align);
            & > * {
                @media (width >= 1160px) {
                    grid-column: 4 / span 6;
                }
                
                @media (912px <= width < 1160px) { 
                    grid-column: 3 / span 8;    
                }
        
                @media (600px <= width < 912px) { 
                    grid-column: 2 / span 10;
                }
        
                @media (width < 600px) {
                    grid-column: 1 / span 4;
                    padding: var(--space-100);
                }
            }
        }

        :host(.center){
            text-align: center;
        }
        :host(.left){   
            text-align: left;
        }
        :host(.right){
            text-align: right;
        }
        *:has(+ lindberg-button) {
            margin-bottom: var(--elements-box-spacing);
        }
        :host(.box-margin) {
            padding: var(--elements-box-margins);
        }
    `]

	data!: { content: TextBlockElementModel; settings: TextSettingsElementModel }

	override connectedCallback(): void {
		super.connectedCallback()
		// if (!this.data.settings) return
		// if (this.data.settings.contentType == 'gridSettings' && this.data.settings?.properties?.textPosition) {
		// console.log('gridSettings', this.data.content.properties.label, this.data.settings?.properties)
		if (this.data.settings?.properties.contentAlign) {
			const [vertical, horizontal] = this.data.settings?.properties.contentAlign.split(' ')
            this.data.settings?.properties.contentAlign?.split(' ').forEach(x => this.classList.add(x))
		}
        this.classList.toggle('box-margin', this.data.settings?.properties?.boxMargin === true)

		// this.style.setProperty('--vertical-align', vertical.replace('middle', 'center').replace('top', 'start').replace('bottom', 'end'))
		// console.log('gridSettings', this.data.settings.properties.textPosition)
		// if(this.data.settings?.properties) this.style.setProperty('--text-align', (this.data.settings.properties as any).textAlign) // TODO: dont
		// if () this.style.setProperty('--text-align', this.data.settings.properties.textPosition)
        if(this.data.settings?.properties?.backgroundColor?.value) this.style.setProperty('background', this.data.settings.properties.backgroundColor.value)
	}

	render() {
        // this.onclick = () => console.log(this.data)
		return html`
            ${unsafeHTML(this.data.content.properties?.text?.markup || '')}
            ${this.data.content.properties.link ? RenderButton(this.data.content.properties.link) : ''}
            `
	}
}
